<div
  *ngIf="options.length === 2 || options.length === 3"
  [class]="'container ' + customWidth"
  (focusout)="focusedOption = -1"
>
  <div class="tabs" [ngClass]="{ error: isError }">
    <span style="width: 100%" *ngFor="let segment of options; let i = index">
      <input type="radio" [attr.aria-labelledby]="'option' + i" />
      <label
        tabindex="0"
        id="option{{ i }}"
        class="tab Body-Bold"
        [class.selected]="isCurrentTab(i)"
        [class.focused]="focusedOption === i"
        [class.double]="options.length === 2"
        [class.triple]="options.length === 3"
        (click)="hovered = true; clickedTab(i)"
        (mouseenter)="hovered = isCurrentTab(i) && !focused"
        (mouseleave)="hovered = false"
        (keyup)="input($event, i)"
      >
        <div class="lbl-text">
          {{ segment }}
        </div>
      </label>
    </span>

    <div
      *ngIf="!activeSelection()"
      class="seperator"
      [class.only-seperator]="options.length === 2"
      [class.first-seperator]="options.length === 3"
    ></div>

    <div *ngIf="!activeSelection() && options.length === 3" class="seperator" [class.second-seperator]="true"></div>

    <span
      [@selectedOption]="selectedOptionString"
      [ngClass]="{
        glider: true,
        double: options.length === 2,
        triple: options.length === 3,
        primary: primaryColor,
        tertiary: !primaryColor,
        hovered: hovered && !focused,
        focused: focused
      }"
    ></span>
  </div>
</div>
